import React from 'react';
import { Spinner } from '../../components/ui';
import { fullName, fmtDate } from '../../utils/helpers';
import { dueText, toTimeInput } from './useReminders';
import ReminderForm from './ReminderForm';

// Mobile (APK) Reminders — reminder picker (dropdown) + tap-to-tick call cards
// with a dial button, built for a member calling guests from their phone.
export default function RemindersMobile({ vm }) {
  const {
    canUse, canManage, canDelete, reminders, selected, selectedId, setSelectedId, activeCount,
    callDate, setCallDate, rows, called, loading, listLoading, modalOpen, openAdd, openEdit, deleteReminder, toggleCalled,
  } = vm;

  const dial = (row) => {
    const mobile = String(row.MobileNumber || '').replace(/\D/g, '');
    if (!mobile) return;
    if (window.AndroidDialer?.openDialer) window.AndroidDialer.openDialer(mobile);
    else window.location.href = `tel:${mobile}`;
  };

  if (!canUse) {
    return (
      <div>
        <div className="page-head"><h1>Reminders</h1></div>
        <div className="card card-pad empty">You do not have access to reminders for this event.</div>
      </div>
    );
  }

  return (
    <div>
      <div className="mobile-toolbar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <strong style={{ fontSize: 16 }}>Reminders</strong>
          <span className="muted" style={{ fontSize: 12 }}>{activeCount} active</span>
          <div style={{ flex: 1 }} />
          {canManage && <button className="btn primary sm" onClick={openAdd}>+ Add</button>}
        </div>
        {reminders.length > 0 && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 8 }}>
            <select value={selectedId || selected?.ReminderId || ''} onChange={e => setSelectedId(e.target.value)}
              style={{ padding: '10px 12px', border: '1px solid var(--line)', borderRadius: 10 }}>
              {reminders.map(r => (
                <option key={r.ReminderId} value={r.ReminderId}>
                  {(r.Title || 'Invitation Calls')} · {toTimeInput(r.ReminderTime)}{Number(r.Active) === 1 ? '' : ' (paused)'}
                </option>
              ))}
            </select>
            <input type="date" value={callDate} onChange={e => setCallDate(e.target.value)}
              style={{ padding: '10px 12px', border: '1px solid var(--line)', borderRadius: 10 }} />
          </div>
        )}
      </div>

      {loading ? <div className="card card-pad"><Spinner /></div> : reminders.length === 0 ? (
        <div className="card card-pad empty">No reminders yet. Tap <strong>+ Add</strong> to set a daily calling time.</div>
      ) : (
        <>
          {selected && (
            <div className="card card-pad" style={{ marginBottom: 10 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div>
                  <strong>{selected.Title || 'Invitation Calls'}</strong>
                  <div className="muted" style={{ fontSize: 12 }}>From {fmtDate(selected.StartDate)} · {dueText(selected, callDate)}</div>
                </div>
                <div style={{ flex: 1 }} />
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 22, fontWeight: 800 }}>{called}/{rows.length}</div>
                  <div className="muted" style={{ fontSize: 11 }}>called</div>
                </div>
              </div>
              {(canManage || canDelete) && (
                <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
                  {canManage && <button type="button" className="btn sm light" onClick={() => openEdit(selected)}>Edit</button>}
                  {canDelete && <button type="button" className="btn sm danger" onClick={() => deleteReminder(selected)}>Delete</button>}
                </div>
              )}
            </div>
          )}

          {listLoading ? <div className="card card-pad"><Spinner /></div> : rows.length === 0 ? (
            <div className="card card-pad empty">No guests found for this reminder.</div>
          ) : (
            <div className="mobile-card-list">
              {rows.map(row => {
                const done = Number(row.Called) === 1;
                return (
                  <div key={row.GuestId} className="card card-pad mobile-record-card" style={{ opacity: done ? 0.6 : 1 }}>
                    <div className="mobile-card-head">
                      <label style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 0 }}>
                        <input type="checkbox" checked={done} onChange={() => toggleCalled(row)} style={{ width: 22, height: 22 }} />
                        <span style={{ minWidth: 0 }}>
                          <strong className="mobile-title">{fullName(row)}</strong>
                          <div className="muted" style={{ fontSize: 12 }}>
                            {row.ReminderSlot ? `${row.ReminderSlot} · ` : ''}{row.FunctionName || '-'}
                          </div>
                        </span>
                      </label>
                      {row.MobileNumber && (
                        <button type="button" className="btn primary sm" onClick={() => dial(row)}>📞 Call</button>
                      )}
                    </div>
                    <div className="mobile-meta">
                      <div>{row.MobileNumber || '-'} <span className={done ? 'chip ok' : 'chip pend'} style={{ marginLeft: 6 }}>{done ? 'Called' : row.InviteStatus || 'Pending'}</span></div>
                      <div className="muted">Added by {(row.AddedByName || '').trim() || '-'}{done ? ` · called by ${(row.CalledByName || '').trim() || 'you'}` : ''}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}

      {modalOpen && <ReminderForm vm={vm} />}
    </div>
  );
}
